import * as amplitude from '@amplitude/analytics-browser'

export const initAmplitude = () => {
  if (process.env.AMPLITUDE_API_KEY && process.env.AMPLITUDE_API_KEY !== 'DEBUG') {
    try {
      amplitude.init(process.env.AMPLITUDE_API_KEY, undefined, {
        defaultTracking: true,
        transport: 'beacon',
      })
      const triggerBeacon = () => {
        // https://www.docs.developers.amplitude.com/data/sdks/browser-2/#set-the-transport-to-use-beacon-only-when-exiting-page
        amplitude.setTransport('beacon')
        // Sets https transport to use `sendBeacon` API
        amplitude.flush()
      }
      window.addEventListener('pagehide', triggerBeacon)
      document.addEventListener('visibilitychange', triggerBeacon)
    } catch (error) {
      //Silent fail as can't log. Just don't want amplitude errors to impact the UI
    }
  }
}

export const setAmplitudeUserId = (userId: string) => {
  if (
    process.env.AMPLITUDE_API_KEY &&
    process.env.AMPLITUDE_API_KEY !== 'DEBUG' &&
    process.browser
  ) {
    try {
      amplitude.setUserId(userId)
    } catch (error) {
      //Silent fail as can't log. Just don't want amplitude errors to impact the UI
    }
  }
}

export type AmplitudeProperties = Record<string, string | number | boolean | undefined>
export type AmplitudeSendEventProperties = {
  baseUrl?: string
}

export const sendAmplitudeEvent = (
  eventType: string,
  eventProperties: AmplitudeProperties,
  options?: AmplitudeSendEventProperties,
) => {
  if (
    process.env.AMPLITUDE_API_KEY &&
    process.env.AMPLITUDE_API_KEY !== 'DEBUG' &&
    process.browser
  ) {
    try {
      if (options?.baseUrl === '/pre-purchase-survey2') {
        const indexOf = Object.values(AmplitudeEventTypes).indexOf(
          eventType as unknown as AmplitudeEventTypes,
        )
        const key = Object.keys(AmplitudeEventTypes)[indexOf]
        eventType = PPQ2AmplitudeEventTypes[key as keyof typeof PPQ2AmplitudeEventTypes]
      }
      amplitude.track(eventType, eventProperties)
    } catch (error) {
      // Silent fail as can't log. Just don't want amplitude errors to impact the UI
    }
  }
}

export enum AmplitudeEventTypes {
  ButtonClick = 'Button Click',
  IntakeSurveyPageLoad = 'Intake Survey Page Load',
  PrePurchaseSurveyPageLoad = 'PrePruchase Survey Page Load', // there is a misspell but we decided to leave it alone to make sure we have a consistent report
  PrePurchaseLandedOnVideoPage = 'PrePurchase Landed on Video Page',
  PrePurchaseIntroVideoPlayed = 'PrePurchase Intro Video Played',
  PPQProgramModuleTabChanged = 'PPQ Program Module Tab Changed',
  QuestionView = 'Question View',
  PrePurchaseSurveyAnswerChoice = 'PrePurchase Survey Answer Choice',
  LeadCapturePopupSubmitted = 'onboarding/popup-submitted',
  MetabolicPrintSurveyPageLoad = 'Metabolic Print Survey Page Load',
  MetabolicPrintShareOpened = 'Metabolic Print Share Opened',
  MetabolicPrintShared = 'Metabolic Print Shared',
  SkipInsuranceClicked = 'Skip Insurance Clicked',
  QuestionAnswered = 'Question Answered',
  CanceledCustomer = 'Canceled Customer',
  SkippedAdultWeight = 'Skipped Lowest Adult Weight',
  SystemDisqualified = 'system-disqualified',
}

// For alternative flow
export enum PPQ2AmplitudeEventTypes {
  PrePurchaseSurveyPageLoad = 'PrePurchase2 Survey Page Load',
  PrePurchaseLandedOnVideoPage = 'PrePurchase2 Landed on Video Page',
  PrePurchaseIntroVideoPlayed = 'PrePurchase2 Intro Video Played',
}

export enum AmplitudeExperimentKeys {
  PPQEmailSMS = 'ppq-email-sms',
  PPQEmailSMSBeginning = 'ppq-email-sms-v2',
  SurveyMigration = 'ppq-surveyjs-migration',
}

export enum PPQEmailSMSVariant {
  V2 = 'variant-2',
}

export enum PPQEmailSMSBeginningVariant {
  V1 = 'variant-1',
  V2 = 'variant-2',
}

export enum SurveyMigrationVariant {
  Treatment = 'treatment',
}
